import { t } from 'i18next';
import { NotificationTypes } from 'server/src/shared/NotificationTypes';

import {
  NotificationIconType,
  NotificationItemData,
  NotificationQueryItem,
} from '../types';
import { routes } from '../../../routes';

const i18prefix = 'notifications.employeeDataChangeRequest';

const iconsByType = new Map<string, NotificationIconType>([
  [NotificationTypes.EMPLOYEE_DATA_CHANGE_REQUEST_APPROVED, 'checkbox-outline'],
]);

const titlesByType = new Map([
  [
    NotificationTypes.EMPLOYEE_DATA_CHANGE_REQUEST_APPROVED,
    t(`${i18prefix}.approved`),
  ],
]);

export const mapEmployeeDataChangeRequestNotificationRenderInfo = (
  src: NotificationQueryItem,
): NotificationItemData | null => {
  const data: NotificationItemData = {
    comment: '',
    urlLabel: '',
    url: routes.requestForms.route.create({}),
    description: '',
  };
  data.icon = iconsByType.get(src.flair__Type__c);
  data.title = titlesByType.get(src.flair__Type__c) || '';

  if (
    src.renderInfo.__typename ===
    'EmployeeDataChangeRequestNotificationRenderInfo'
  ) {
    const edcr = src.renderInfo.employeeDataChangeRequest;
    data.urlLabel =
      edcr?.flair__Description__c ?? edcr?.requestForm?.Name ?? '';
  }

  return data;
};
